module.exports = function (r) {
  var n = {};
  function o(e) {
    if (n[e]) return n[e].exports;
    var t = n[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return r[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  return o.m = r, o.c = n, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) {
      o.d(r, n, function (e) {
        return t[e];
      }.bind(null, n));
    }
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "useVisibilityHook", function () {
    return b;
  }), r.d(t, "LazyLoad", function () {
    return u;
  });
  var y = r(0),
    s = r.n(y);
  function n(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function p(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? n(Object(r), !0).forEach(function (e) {
        o(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  function o(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  function d(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
        n = !0,
        o = !1,
        i = void 0;
      try {
        for (var u, c = e[Symbol.iterator](); !(n = (u = c.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          n || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }
      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return i(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return i(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function i(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }
    return n;
  }
  var v = {
      root: null,
      threshold: 1,
      rootMargin: "0px"
    },
    b = function b(e, t) {
      function r() {
        l(!0);
      }
      function n(e) {
        d(e, 1)[0].isIntersecting && (l(!0), o.disconnect());
      }
      var o,
        i = 0 < arguments.length && void 0 !== e ? e : {},
        u = 1 < arguments.length && void 0 !== t && t,
        c = d(Object(y.useState)(u), 2),
        f = c[0],
        l = c[1],
        a = d(Object(y.useState)(null), 2),
        s = a[0],
        b = a[1];
      return Object(y.useEffect)(function () {
        u && r();
      }, [u]), Object(y.useEffect)(function () {
        if (s) return (o = new IntersectionObserver(n, p(p({}, v), i))).observe(s), function () {
          return o && o.disconnect && o.disconnect();
        };
      }, [s, i.root, i.rootMargin, i.threshold]), {
        setElement: b,
        isVisible: f,
        forceVisible: r,
        forceCheck: function forceCheck() {
          o.unobserve(s), o.observe(s);
        }
      };
    },
    u = function u(e) {
      var t = e.children,
        r = e.config,
        n = void 0 === r ? {} : r,
        o = e.style,
        i = e.as,
        u = e.forceVisible,
        c = i || "div",
        f = b(n, u),
        l = f.setElement,
        a = f.isVisible;
      return s.a.createElement(c, {
        ref: l,
        style: o
      }, a && t);
    };
}]);